import React from 'react';
import { bool, string } from 'prop-types';

import {
  LoadingCurtainCoverWrapper,
  LoadingCurtainSpinnerWrapper,
} from './LoadingCurtainStyles';

export const LoadingCurtain = ({
  showSpinner,
  isFullscreen,
  className,
  name,
}) => (
  <LoadingCurtainCoverWrapper
    data-test={name}
    isFullscreen={isFullscreen}
    className={className}
  >
    <LoadingCurtainSpinnerWrapper>
      {!!showSpinner && <div className="spinner-border" color="primary" />}
    </LoadingCurtainSpinnerWrapper>
  </LoadingCurtainCoverWrapper>
);

LoadingCurtain.propTypes = {
  className: string,
  isFullscreen: bool,
  name: string,
  showSpinner: bool,
};

LoadingCurtain.defaultProps = {
  showSpinner: true,
  isFullscreen: false,
  className: '',
};
